import { Flex } from '@lego/klik-ui';
import { Loader } from '@/components/common';
import { deviceTypeTableColumns } from '@/components/common/table/column_definitions/DeviceType';
import { TableStoreProvider } from '@/components/common/table/store/Context';
import { Table } from '@/components/common/table/Table';
import { useDocumentTitle } from '@/hooks/common';
import { type DeviceType, useDeviceTypes } from '@/hooks/device_type';
import { useRegisterPageContext } from '@/providers/PageContextProvider';

const tableDescription =
  'These are the device hardware types provisionable from EMMA, including their architecture and supported EMMA OS versions.';

export const DeviceTypesPage = () => {
  useDocumentTitle('Device Types');

  const { data, isLoading } = useDeviceTypes({ limit: 500 });

  useRegisterPageContext(data);

  if (isLoading) {
    return <Loader />;
  }

  const deviceTypes: DeviceType[] = data?.deviceTypes ?? [];

  return (
    <Flex direction="column" gap="4">
      <TableStoreProvider initialSorting={[{ desc: false, id: 'vendor' }]} name="DeviceTypes">
        <Table
          columns={deviceTypeTableColumns}
          data={deviceTypes}
          description={tableDescription}
          title="Device Types"
        />
      </TableStoreProvider>
    </Flex>
  );
};
